import { QuestionBase } from './question-base';

export class SelectQuestion extends QuestionBase<string> {
   ptctNo = 'select';
}
